import httpService from "V2.0/services/httpService";

const ROUTES = {
  COMM_BINDINGS: "/pipelines/whitelabelCommunicationBindings",
  ASSISTANTS: "/assistants/whitelabelGetAssistants",
  UPDATE_PIPELINE: "/pipelines/whitelabelUpdatePipeline",
  GET_PIPELINES: "/pipelines/whitelabelGetPipelines",
  GET_PIPELINE: "/pipelines/whitelabelGetPipeline",
  CREATE_PIPELINE: "/pipelines/whitelabelCreatePipeline",
  GET_PIPELINE_RUNS: "/pipelineRuns/whitelabelGetPipelineRuns",
  DELETE_PIPELINE: "/pipelines/whitelabelDeletePipeline",
};

function getPipeline({ workspaceId, pipelineId }) {
  return httpService.get(`${ROUTES.GET_PIPELINE}/${workspaceId}/${pipelineId}`);
}

function getPipelines({ workspaceId }) {
  return httpService.get(`${ROUTES.GET_PIPELINES}/${workspaceId}`);
}

function createPipeline({ workspaceId, payload }) {
  return httpService.post(`${ROUTES.CREATE_PIPELINE}/${workspaceId}`, payload);
}

function addCommBinding({ workspaceId, pipelineId, nodeId, payload }) {
  return httpService.put(
    `${ROUTES.COMM_BINDINGS}/${workspaceId}/${pipelineId}/${nodeId}`,
    payload
  );
}

function getAssistants({ workspaceId }) {
  return httpService.get(`${ROUTES.ASSISTANTS}/${workspaceId}`);
}

function updatePipeline({ workspaceId, pipelineId, payload }) {
  return httpService.patch(
    `${ROUTES.UPDATE_PIPELINE}/${workspaceId}/${pipelineId}`,
    payload
  );
}

function getPipelineRuns({ workspaceId }) {
  return httpService.get(`${ROUTES.GET_PIPELINE_RUNS}/${workspaceId}`);
}

function deletePipeline({ workspaceId, pipelineId }) {
  return httpService.delete(
    `${ROUTES.DELETE_PIPELINE}/${workspaceId}/${pipelineId}`
  );
}

export {
  addCommBinding,
  getAssistants,
  deletePipeline,
  updatePipeline,
  getPipeline,
  getPipelines,
  createPipeline,
  getPipelineRuns,
};
